import { isMobileLayout } from '@psl/components/styles/responsive';
import { AbstractPathResolver, PathResolveResult } from '../PathResolver';

export class SettingsPathResolver extends AbstractPathResolver {
  resolveStateFromPath(): PathResolveResult {
    if (this.context.path.startsWith('/settings/')) {
      // todo(andyl): fix mobile deep link to settings pages later.
      if (isMobileLayout()) {
        return {
          index: 1,
          routes: [
            { name: 'home' },
            {
              name: 'settings',
            },
          ],
        };
      }
    }
  }
}
